var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.936,
    height: 26.922,
    viewBox: "0 0 34.936 26.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1390 -2500.935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.362,13.293a1.107,1.107,0,0,0-.449-.889L12.492,5.411A1.155,1.155,0,0,0,11.3,5.3a1.109,1.109,0,0,0-.628,1v3H3.1a1.122,1.122,0,0,0-1.133,1.113v5.765A1.123,1.123,0,0,0,3.1,17.29h7.574v3a1.108,1.108,0,0,0,.629,1,1.156,1.156,0,0,0,.5.117,1.142,1.142,0,0,0,.683-.226l9.421-7A1.108,1.108,0,0,0,22.362,13.293Z",
    transform: "translate(1388.031 2495.748)",
    fill: "#0533b3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.491,17.567H24.9v-3a1.11,1.11,0,0,0-.63-1,1.151,1.151,0,0,0-1.188.11l-9.4,6.994a1.1,1.1,0,0,0,0,1.773l9.4,6.993a1.151,1.151,0,0,0,1.19.109,1.112,1.112,0,0,0,.629-1v-3h7.593a1.122,1.122,0,0,0,1.133-1.113V18.68A1.123,1.123,0,0,0,32.491,17.567Z",
    transform: "translate(1391.313 2498.189)",
    fill: "#0533b3",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.0b9aa39e4170a01dabec336e835bcdbc.svg";
export { ForwardRef as ReactComponent };